import React from 'react';
import { Dialog } from '@material-ui/core';
import { Formik, Field, Form} from 'formik';
import * as yup from 'yup';
import axios from 'axios';
import { FormikTextField } from '../../../shared/Formik/FormikTextField'
import { useAuth } from '../../../context/auth';
import { SupportAnswerProps } from './SupportAnswer.interface';
import {
    StyledDialogContent,
    DialogTitle,
    DialogDescription,
    Label,
    SaveButton,
    CloseButton,
    FlexWrapper
} from '../Dialogs.styles';

const validationSchema = yup.object().shape({
    message: yup.string().required().label('Reason')
})

export function SupportAnswer({ open, setOpen, questionData, refresh}: SupportAnswerProps) {
    const { authToken } = useAuth();
    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            fullWidth
        >
            <StyledDialogContent>
                <DialogTitle>Support question</DialogTitle>
                <Label>Subject:</Label>
                <DialogDescription>{questionData.subject}</DialogDescription>
                <Label>Question:</Label>
                <DialogDescription>{questionData.description}</DialogDescription>
                <Label>Campaign name:</Label>
                <DialogDescription>{questionData.campaignTitle}</DialogDescription>
                {questionData.answered ?
                    <>
                        <Label>Admin email:</Label>
                        <DialogDescription>{questionData.adminUser?.email}</DialogDescription>
                        <Label>Admin answer:</Label>
                        <DialogDescription>{questionData.adminAnswer}</DialogDescription>
                    </>
                    :
                        <Formik
                            initialValues={{
                                message: ""
                            }}
                            onSubmit={(values) => {
                                axios.patch(`${process.env.REACT_APP_BASE_URL}/api/support/questions/${questionData.id}/answer/`, values, {headers: { DTOKEN: `${authToken}`}}).then(() => {
                                    refresh();
                                    setOpen(false);
                                })
                            }}
                            validationSchema={validationSchema}
                        >
                            <Form>
                                <Label>Admin answer</Label>
                                <Field
                                    name="message"
                                    fullWidth
                                    variant="outlined"
                                    multiline
                                    rows={4}
                                    component={FormikTextField}
                                />
                                <FlexWrapper>
                                    <CloseButton type="button" onClick={() => setOpen(false)}>Cancel</CloseButton>
                                    <SaveButton type="submit">Answer</SaveButton>
                                </FlexWrapper>
                            </Form>
                        </Formik>       

                }
            </StyledDialogContent>
        </Dialog>
    )
}
